module.exports = __webpack_public_path__ + "img/kyzkzxt3.e4642357.jpg";